import React from "react";
import PropTypes from "prop-types";
import {Box} from "@mui/material";
import StaticEditor from "../editor/StaticEditor";
import {applyWorkflowName} from "../../resources/utils/stringUtils";
import {isString, map} from "underscore";

const TEMPLATE_DISPLAY_LENGTH = 10;
const REPORT_OR_TEMPLATE_TEXT_FIELDS = ["template", "reportTemplate", "content"];

const truncateTemplate = (template) =>
  isString(template) && template.length > TEMPLATE_DISPLAY_LENGTH ?
    template.slice(0, TEMPLATE_DISPLAY_LENGTH) + "..." :
    template;

const isHtmlContent = (value) => isString(value) && value.trimStart().startsWith("<");

const handleTemplateDisplay = (input) => {
  if (!input) {
    return {displayData: {}, editorText: null};
  }

  const displayData = {...input};
  const editorText =
    input.template ||
    input.result?.template ||
    (isHtmlContent(input.result?.content) && input.tool !== "ui.get.field" ?
      input.result.content :
      null) ||
      input.content ||
      null;

  if (isString(input.template)) {
    displayData.template = truncateTemplate(input.template);
  }
  if (isString(input.content)) {
    displayData.content = truncateTemplate(input.content);
  }

  if (displayData.result && !isString(displayData.result)) {
    const truncatedResult = {};
    map(REPORT_OR_TEMPLATE_TEXT_FIELDS, (field) => {
      if (isString(displayData.result[field]) && isHtmlContent(displayData.result[field])) {
        truncatedResult[field] = truncateTemplate(displayData.result[field]);
      } else if (
        isString(displayData.result[field]?.newValue) &&
        isHtmlContent(displayData.result[field].newValue)
      ) {
        truncatedResult[field] = {
          ...displayData.result[field],
          newValue: truncateTemplate(displayData.result[field].newValue),
        };
      }
    });
    if (displayData.result.results && !isString(displayData.result.results)) {
      const truncatedResults = {};
      map(REPORT_OR_TEMPLATE_TEXT_FIELDS, (field) => {
        if (
          isString(displayData.result.results[field]) &&
          isHtmlContent(displayData.result.results[field])
        ) {
          truncatedResults[field] = truncateTemplate(displayData.result.results[field]);
        }
      });
      truncatedResult.results = {...displayData.result.results, ...truncatedResults};
    }
    displayData.result = {...displayData.result, ...truncatedResult};
  }

  return {displayData, editorText};
};

const ConfirmationItemList = ({items, responseWorkflowName, showStatus}) =>
  map(items, (item, index) => {
    const {displayData, editorText} = handleTemplateDisplay(item.input);

    return (
      <Box key={index} sx={{mb: 1}}>
        {item.description &&
          `${index + 1}. ${
            showStatus ? (item.status === "approved" ? "✅" : "🚫") + " " : ""
          }${item.description}`}
        {item.description && "\n"}
        {JSON.stringify(displayData, null, 2)}
        {editorText && (
          <Box sx={{mt: 0.5, p: 1}}>
            <StaticEditor
              defaultValue={applyWorkflowName(editorText, responseWorkflowName)}
              name={`confirmation-template-editor-${index}`}
              defaultStyle="padding: 8px"
            />
          </Box>
        )}
      </Box>
    );
  });

ConfirmationItemList.propTypes = {
  items: PropTypes.array.isRequired,
  responseWorkflowName: PropTypes.object,
  showStatus: PropTypes.bool,
};

export default ConfirmationItemList;
